
import { Union, Record } from "../fable_modules/fable-library-js.5.0.0-rc.2/Types.js";
import { lambda_type, unit_type, list_type, union_type, record_type, bool_type, option_type, class_type, string_type } from "../fable_modules/fable-library-js.5.0.0-rc.2/Reflection.js";
import { createElement } from "react";
import React from "react";
import * as react from "react";
import { useTranslation } from "react-i18next";
import { TableControl$1, Table } from "./Table/Table.js";
import { empty as empty_1, map, ofArray, singleton as singleton_1, tryFind, tryHead, toArray } from "../fable_modules/fable-library-js.5.0.0-rc.2/List.js";
import { ColumnDefinition$1, CellContent } from "./Table/Types.js";
import { ColoredDot } from "../Components/ColoredDot.js";
import { append, empty, singleton, delay, toList } from "../fable_modules/fable-library-js.5.0.0-rc.2/Seq.js";
import Shipment_Add from "../../public/assets/icons/Shipment_Add.svg";
import { SetId__get_unwrap, FormState__setValidationResponse_5219762A, FormState__startLoading, DataTransfer_LinkDocumentReminderDto, FormState_get_empty, RequestedValue$1, FormState_$reflection, RequestedValue$1_$reflection, ClientApiResponse$1_$reflection } from "../Shared/Shared.js";
import { ToolWithQuantityDetailDto_$reflection, ToolDetailDto_$reflection } from "../Shared/Tool.js";
import { ConsumableDetailDto_$reflection } from "../Shared/Consumable.js";
import { DataTransfer_DetailSet_$reflection } from "../Shared/Set.js";
import { UploadType_$reflection } from "./Dialogs/FileUploadDialog.js";
import { Cmd_ofEffect, Cmd_batch, Cmd_none } from "../fable_modules/Fable.Elmish.5.0.2/cmd.fs.js";
import { getConsumableDetailDto, postDocumentReminderLink } from "../Requests/Consumable.js";
import { getToolWithQuantityDetailDto, postDocumentReminderLink as postDocumentReminderLink_1 } from "../Requests/ToolWithQuantity.js";
import { postDocumentReminderLink as postDocumentReminderLink_2 } from "../Requests/Set.js";
import { Cmd_getToolDetailDto, Cmd_postDocumentReminderLink } from "../Requests/Tool.js";
import { Cmd_successToast, Cmd_errorToast } from "../Components/Toast.js";
import { Cmd_OfPromise_either } from "../fable_modules/Fable.Elmish.5.0.2/cmd.fs.js";
import { PromiseBuilder__Delay_62FBFDE1, PromiseBuilder__Run_212F1D4B } from "../fable_modules/Fable.Promise.2.0.0/Promise.fs.js";
import { promise } from "../fable_modules/Fable.Promise.2.0.0/PromiseImpl.fs.js";
import { addPrefix, fetchWithDecoder } from "../Communication.js";
import { Types_RequestProperties } from "../fable_modules/Fable.Fetch.2.1.0/Fetch.fs.js";
import { Reader_$ctor_Z3F6BC7B1, Reader__Read_24524716 } from "../fable_modules/Fable.Remoting.MsgPack.1.25.0/Read.fs.js";
import { concat } from "../fable_modules/fable-library-js.5.0.0-rc.2/String.js";
import { React_useElmish_Z6C327F2E } from "../fable_modules/Feliz.UseElmish.2.5.0/UseElmish.fs.js";
import { ProgramModule_mkProgram } from "../fable_modules/Fable.Elmish.5.0.2/program.fs.js";
import { reactApi, reactElement } from "../fable_modules/Feliz.2.9.0/Interop.fs.js";
import { createObj } from "../fable_modules/fable-library-js.5.0.0-rc.2/Util.js";
import { ModalSheet } from "../Components/ModalSheet.js";
import { Skeleton } from "../Components/Skeleton.js";
import { defaultOf } from "../fable_modules/fable-library-js.5.0.0-rc.2/Util.js";
import { ConfirmationDialog } from "../Components/Dialog.js";
import { TextButton } from "../Components/Button.js";

export class ReminderTable_TableReminder extends Record {
    constructor(Id, ExecutionDate, Title, Description, IsConfirmed, ConfirmationComment, Date$) {
        super();
        this.Id = Id;
        this.ExecutionDate = ExecutionDate;
        this.Title = Title;
        this.Description = Description;
        this.IsConfirmed = IsConfirmed;
        this.ConfirmationComment = ConfirmationComment;
        this.Date = Date$;
    }
}

export function ReminderTable_TableReminder_$reflection() {
    return record_type("Widgets.LinkDocumentWithReminderModal.ReminderTable.TableReminder", [], ReminderTable_TableReminder, () => [["Id", string_type], ["ExecutionDate", option_type(class_type("System.DateTime"))], ["Title", string_type], ["Description", string_type], ["IsConfirmed", bool_type], ["ConfirmationComment", string_type], ["Date", class_type("System.DateTime")]]);
}

export function ReminderTable_ReminderTable(props) {
    let TableRows, Options;
    const t = useTranslation()[0];
    const xs = [createElement(Table, (TableRows = toArray(props.Reminders), (Options = {
        BorderStyle: "row",
        CSVDownload: false,
        ConfigurableColumns: false,
        CustomTableFilters: false,
        DefaultSortColumn: ["uploadDate", "asc"],
        Fullscreen: false,
        GlobalSearch: false,
        RowSelection: "singleRow",
        SaveTableConfiguration: false,
    }, {
        ColumnDefinitions: [new ColumnDefinition$1("date", "", t("general.planned_date"), (dto) => (new CellContent(6, [dto.Date])), "dateRange", "date"), new ColumnDefinition$1("executionDate", "", t("general.execution_date"), (dto_1) => (new CellContent(6, [dto_1.ExecutionDate])), "dateRange", "date"), new ColumnDefinition$1("state", "", t("general.done"), (reminderDate) => (reminderDate.IsConfirmed ? (new CellContent(1, [createElement(ColoredDot, {
            Color: "green",
        })])) : (new CellContent(1, [createElement(ColoredDot, {
            Color: "orange",
        })]))), "none", "text"), new ColumnDefinition$1("name", "", t("general.name"), (dto_2) => (new CellContent(0, [dto_2.Title])), "select", "text"), new ColumnDefinition$1("description", "", t("general.description"), (dto_3) => (new CellContent(0, [dto_3.Description])), "text", "text"), new ColumnDefinition$1("comment", "", t("general.comment"), (dto_4) => (new CellContent(0, [dto_4.ConfirmationComment])), "text", "text")],
        Controls: toList(delay(() => {
            const matchValue = props.UserData.Role;
            switch (matchValue) {
                case "system":
                case "administrator":
                case "toolManager":
                    return singleton(new TableControl$1(t("general.add"), Shipment_Add(), (row) => {
                        const matchValue_1 = tryHead(row);
                        if (matchValue_1 == null) {
                        }
                        else {
                            const row_1 = matchValue_1;
                            props.OnSelectTableReminder(tryFind((reminder) => (reminder.Id === row_1.Id), props.Reminders));
                        }
                    }, true, false, ""));
                default: {
                    return empty();
                }
            }
        })),
        Options: Options,
        TableKey: "not-defined-table",
        TableRows: TableRows,
    })))];
    return react.createElement(react.Fragment, {}, ...xs);
}

class Modal_Msg extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["SelectTableRow", "LinkReminderWithDocument", "LinkReminderWithDocumentResponse", "FetchReminders", "ToolFetched", "ConsumableFetched", "ToolWithQuantityFetched", "SetFetched", "FetchError"];
    }
}

function Modal_Msg_$reflection() {
    return union_type("Widgets.LinkDocumentWithReminderModal.Modal.Msg", [], Modal_Msg, () => [[["Item", option_type(ReminderTable_TableReminder_$reflection())]], [], [["Item", ClientApiResponse$1_$reflection(string_type)]], [], [["Item", ToolDetailDto_$reflection()]], [["Item", ConsumableDetailDto_$reflection()]], [["Item", ToolWithQuantityDetailDto_$reflection()]], [["Item", DataTransfer_DetailSet_$reflection()]], [["Item", class_type("System.Exception")]]]);
}

class Modal_State extends Record {
    constructor(Reminders, UploadType, DocumentId, OnClose, OnSuccessCallback, FormState, SelectedRow) {
        super();
        this.Reminders = Reminders;
        this.UploadType = UploadType;
        this.DocumentId = DocumentId;
        this.OnClose = OnClose;
        this.OnSuccessCallback = OnSuccessCallback;
        this.FormState = FormState;
        this.SelectedRow = SelectedRow;
    }
}

function Modal_State_$reflection() {
    return record_type("Widgets.LinkDocumentWithReminderModal.Modal.State", [], Modal_State, () => [["Reminders", RequestedValue$1_$reflection(list_type(ReminderTable_TableReminder_$reflection()))], ["UploadType", UploadType_$reflection()], ["DocumentId", string_type], ["OnClose", lambda_type(unit_type, unit_type)], ["OnSuccessCallback", lambda_type(unit_type, unit_type)], ["FormState", FormState_$reflection()], ["SelectedRow", option_type(ReminderTable_TableReminder_$reflection())]]);
}

function Modal_init(onClose, uploadType, onSuccessCallback, documentId) {
    return [new Modal_State(new RequestedValue$1(0, []), uploadType, documentId, onClose, onSuccessCallback, FormState_get_empty(), undefined), singleton_1((dispatch) => {
        dispatch(new Modal_Msg(3, []));
    })];
}

function Modal_update(msg, state) {
    switch (msg.tag) {
        case 1: {
            const matchValue = state.SelectedRow;
            if (matchValue == null) {
                return [state, Cmd_none()];
            }
            else {
                const row_1 = matchValue;
                const matchValue_1 = state.UploadType;
                switch (matchValue_1.tag) {
                    case 1: {
                        const dto_1 = new DataTransfer_LinkDocumentReminderDto(row_1.Id, state.DocumentId);
                        return [new Modal_State(state.Reminders, state.UploadType, state.DocumentId, state.OnClose, state.OnSuccessCallback, FormState__startLoading(state.FormState), state.SelectedRow), postDocumentReminderLink(matchValue_1.fields[0], dto_1, (Item_2) => (new Modal_Msg(2, [Item_2])), (Item_3) => (new Modal_Msg(8, [Item_3])))];
                    }
                    case 2: {
                        const dto_2 = new DataTransfer_LinkDocumentReminderDto(row_1.Id, state.DocumentId);
                        return [new Modal_State(state.Reminders, state.UploadType, state.DocumentId, state.OnClose, state.OnSuccessCallback, FormState__startLoading(state.FormState), state.SelectedRow), postDocumentReminderLink_1(matchValue_1.fields[0], dto_2, (Item_4) => (new Modal_Msg(2, [Item_4])), (Item_5) => (new Modal_Msg(8, [Item_5])))];
                    }
                    case 3: {
                        const dto_3 = new DataTransfer_LinkDocumentReminderDto(row_1.Id, state.DocumentId);
                        return [new Modal_State(state.Reminders, state.UploadType, state.DocumentId, state.OnClose, state.OnSuccessCallback, FormState__startLoading(state.FormState), state.SelectedRow), postDocumentReminderLink_2(matchValue_1.fields[0], dto_3, (Item_6) => (new Modal_Msg(2, [Item_6])), (Item_7) => (new Modal_Msg(8, [Item_7])))];
                    }
                    case 4:
                        return [state, Cmd_none()];
                    default: {
                        const dto = new DataTransfer_LinkDocumentReminderDto(row_1.Id, state.DocumentId);
                        return [new Modal_State(state.Reminders, state.UploadType, state.DocumentId, state.OnClose, state.OnSuccessCallback, FormState__startLoading(state.FormState), state.SelectedRow), Cmd_postDocumentReminderLink(matchValue_1.fields[0], dto, (Item) => (new Modal_Msg(2, [Item])), (Item_1) => (new Modal_Msg(8, [Item_1])))];
                    }
                }
            }
        }
        case 2: {
            const response = msg.fields[0];
            if (response.tag === 1) {
                return [new Modal_State(state.Reminders, state.UploadType, state.DocumentId, state.OnClose, state.OnSuccessCallback, FormState__setValidationResponse_5219762A(state.FormState, response.fields[0]), state.SelectedRow), Cmd_errorToast("validation.toast")];
            }
            else {
                return [new Modal_State(state.Reminders, state.UploadType, state.DocumentId, state.OnClose, state.OnSuccessCallback, FormState_get_empty(), state.SelectedRow), Cmd_batch(ofArray([Cmd_ofEffect((_arg) => {
                    state.OnSuccessCallback();
                }), Cmd_successToast("general.saved_successfully"), Cmd_ofEffect((_arg_1) => {
                    state.OnClose();
                })]))];
            }
        }
        case 3: {
            const matchValue_2 = state.UploadType;
            switch (matchValue_2.tag) {
                case 1:
                    return [state, getConsumableDetailDto((Item_10) => (new Modal_Msg(5, [Item_10])), (Item_11) => (new Modal_Msg(8, [Item_11])), matchValue_2.fields[0])];
                case 2:
                    return [state, getToolWithQuantityDetailDto(matchValue_2.fields[0], (Item_12) => (new Modal_Msg(6, [Item_12])), (Item_13) => (new Modal_Msg(8, [Item_13])))];
                case 3:
                    return [state, Cmd_OfPromise_either((url) => PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => (fetchWithDecoder(0, addPrefix(url), singleton_1(new Types_RequestProperties(0, ["GET"])), "application/json", (response_1) => {
                        const pr = response_1.arrayBuffer();
                        return pr.then((blob) => Reader__Read_24524716(Reader_$ctor_Z3F6BC7B1(new Uint8Array(blob)), DataTransfer_DetailSet_$reflection()));
                    })))), concat("/api/sets/", SetId__get_unwrap(matchValue_2.fields[0]), ..."/details"), (Item_14) => (new Modal_Msg(7, [Item_14])), (Item_15) => (new Modal_Msg(8, [Item_15])))];
                case 4:
                    return [state, Cmd_none()];
                default:
                    return [state, Cmd_getToolDetailDto((Item_8) => (new Modal_Msg(4, [Item_8])), (Item_9) => (new Modal_Msg(8, [Item_9])), matchValue_2.fields[0])];
            }
        }
        case 4:
            return [new Modal_State(new RequestedValue$1(1, [map((reminder) => (new ReminderTable_TableReminder(reminder.Id, reminder.ExecutionDate, reminder.Title, reminder.Description, reminder.IsConfirmed, reminder.ConfirmationComment, reminder.Date)), msg.fields[0].ReminderDates)]), state.UploadType, state.DocumentId, state.OnClose, state.OnSuccessCallback, state.FormState, state.SelectedRow), Cmd_none()];
        case 6:
            return [new Modal_State(new RequestedValue$1(1, [map((reminder_1) => (new ReminderTable_TableReminder(reminder_1.Id, reminder_1.ExecutionDate, reminder_1.Title, reminder_1.Description, reminder_1.IsConfirmed, reminder_1.ConfirmationComment, reminder_1.Date)), msg.fields[0].Reminders)]), state.UploadType, state.DocumentId, state.OnClose, state.OnSuccessCallback, state.FormState, state.SelectedRow), Cmd_none()];
        case 5:
            return [new Modal_State(new RequestedValue$1(1, [map((reminder_2) => (new ReminderTable_TableReminder(reminder_2.Id, reminder_2.ExecutionDate, reminder_2.Title, reminder_2.Description, reminder_2.IsConfirmed, reminder_2.ConfirmationComment, reminder_2.Date)), msg.fields[0].Reminders)]), state.UploadType, state.DocumentId, state.OnClose, state.OnSuccessCallback, state.FormState, state.SelectedRow), Cmd_none()];
        case 7:
            return [new Modal_State(new RequestedValue$1(1, [map((reminder_3) => (new ReminderTable_TableReminder(reminder_3.Id, reminder_3.ExecutionDate, reminder_3.Title, reminder_3.Description, reminder_3.IsConfirmed, reminder_3.ConfirmationComment, reminder_3.Date)), msg.fields[0].Planning.Reminders)]), state.UploadType, state.DocumentId, state.OnClose, state.OnSuccessCallback, state.FormState, state.SelectedRow), Cmd_none()];
        case 8:
            return [state, Cmd_none()];
        default:
            return [new Modal_State(state.Reminders, state.UploadType, state.DocumentId, state.OnClose, state.OnSuccessCallback, state.FormState, msg.fields[0]), Cmd_none()];
    }
}

function Modal_LinkedDocumentsModalSheet(props) {
    let elems_1, matchValue, elems;
    const t = useTranslation()[0];
    const patternInput_1 = React_useElmish_Z6C327F2E(() => ProgramModule_mkProgram(() => Modal_init(props.OnClose, props.UploadType, props.OnSuccessCallback, props.DocumentId), Modal_update, (_arg_1, _arg_1_1) => {
    }), undefined, [props.IsOpen]);
    const state_1 = patternInput_1[0];
    const dispatch = patternInput_1[1];
    return reactElement("div", createObj(singleton_1((elems_1 = [createElement(ModalSheet, {
        CloseButtonTestId: "",
        Content: (matchValue = state_1.Reminders, (matchValue.tag === 0) ? createElement(Skeleton, {
            Variant: "table",
        }) : reactElement("div", createObj(singleton_1((elems = toList(delay(() => {
            let Title;
            return append((state_1.SelectedRow == null) ? singleton(defaultOf()) : singleton(createElement(ConfirmationDialog, (Title = t("general.add"), {
                Description: t("document_reminder_relation.add_query"),
                FormState: state_1.FormState,
                IsOpen: props.IsOpen,
                OnClose: props.OnClose,
                OnConfirm: state_1.FormState.IsLoading ? (() => {
                }) : (() => {
                    dispatch(new Modal_Msg(1, []));
                }),
                Title: Title,
            }))), delay(() => singleton(createElement(ReminderTable_ReminderTable, {
                OnSelectTableReminder: (tableReminder) => {
                    dispatch(new Modal_Msg(0, [tableReminder]));
                },
                Reminders: matchValue.fields[0],
                UploadType: props.UploadType,
                UserData: props.UserData,
            }))));
        })), ["children", reactApi.Children.toArray(Array.from(elems))]))))),
        Controls: empty_1(),
        IsModalOpen: props.IsOpen,
        OnClose: props.OnClose,
    })], ["children", reactApi.Children.toArray(Array.from(elems_1))]))));
}

export function Modal_OpenLinkDocumentWithReminderModalSheet(props) {
    let elems;
    const patternInput = useTranslation();
    const patternInput_1 = reactApi.useState(undefined);
    const setIsLinkDocumentWithReminderModalSheetOpen = patternInput_1[1];
    const isLinkDocumentWithReminderModalSheet = patternInput_1[0];
    return reactElement("div", createObj(singleton_1((elems = toList(delay(() => append((isLinkDocumentWithReminderModalSheet == null) ? (empty()) : singleton(createElement(Modal_LinkedDocumentsModalSheet, {
        DocumentId: props.DocumentId,
        IsOpen: isLinkDocumentWithReminderModalSheet != null,
        OnClose: () => {
            props.OnClose();
            setIsLinkDocumentWithReminderModalSheetOpen(undefined);
        },
        OnSuccessCallback: props.OnSuccessCallback,
        UploadType: props.UploadType,
        UserData: props.UserData,
    })), delay(() => singleton(createElement(TextButton, {
        ComponentState: "enabled",
        Label: patternInput[0]("general.add"),
        OnClick: () => {
            setIsLinkDocumentWithReminderModalSheetOpen(props.UploadType);
        },
        TestId: "open-add-linked-document-modal-icon-button",
        Variant: "blueButton",
    })))))), ["children", reactApi.Children.toArray(Array.from(elems))]))));
}

